import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Helper from "./Helper";
import { handlePhotoUpload } from "../../filestackRequestViaApi";
import { useDispatch, useSelector } from "react-redux";
import {
  getAppraisalData,
  selectAppraisal,
  getRequiredPhotoData
} from "../../../../store/selectors";
import { imageUploadSlice } from "../../../../store/slices/ImageUploads";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch as useAxiosDispatch } from "../../context/axiosContext";

export default function HelperContainer() {
  const { id } = useParams();
  const requiredPhotoData = useSelector(getRequiredPhotoData);
  const { images: savedImages } = useSelector(getAppraisalData);
  const {
    data: { appraisalSessionId }
  } = useSelector(selectAppraisal);
  const axiosDispatch = useAxiosDispatch();

  const [currentHelper, setCurrentHelper] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // handles back nav without saving image
  useEffect(() => {
    dispatch(imageUploadSlice.actions.clearUnSavedImages(savedImages));
    dispatch(imageUploadSlice.actions.clearCurrentImageIdentifiers());
  }, [dispatch, savedImages]);

  useEffect(() => {
    dispatch(imageUploadSlice.actions.clearCurrentUploads());
    dispatch(imageUploadSlice.actions.setMaxUploads(10));
  }, [dispatch]);

  useEffect(() => {
    const currentHelper = requiredPhotoData.find((data) => data.id === id);
    dispatch(imageUploadSlice.actions.setCurrentUploadHelper(currentHelper));
    setCurrentHelper(currentHelper);
  }, [dispatch, id, requiredPhotoData]);

  const handleChange = async (images) => {
    if (images) {
      navigate(`/image-upload-progress/${id}`);
      handlePhotoUpload(
        images,
        dispatch,
        currentHelper,
        axiosDispatch,
        appraisalSessionId
      );
    }
  };

  return (
    <>
      {currentHelper && (
        <Helper currentHelper={currentHelper} handleChange={handleChange} />
      )}
    </>
  );
}

HelperContainer.propTypes = {
  id: PropTypes.string
};
